/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const React = require('react');
const { ThemeProvider } = require('react-jss');
const theme = require('./src/settings/theme');

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const suppressPatterns = [
    'componentWillMount has been renamed',
    'componentWillReceiveProps has been renamed',
    'componentWillUpdate has been renamed'
  ];
  const shouldSuppress = args => {
    if (!args || !args.length) return false;
    const first = args[0];
    if (typeof first !== 'string') return false;
    return suppressPatterns.some(pattern => first.includes(pattern));
  };

  const warn = console.warn;
  const error = console.error;
  console.warn = (...args) => {
    if (shouldSuppress(args)) return;
    return warn.apply(console, args);
  };
  console.error = (...args) => {
    if (shouldSuppress(args)) return;
    return error.apply(console, args);
  };
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
  const event = new CustomEvent(
    'route-change',
    { detail: { location, prevLocation } }
  );
  window.dispatchEvent(event);
};

exports.wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    {element}
  </ThemeProvider>
);
